import pino from 'pino';

// https://getpino.io/#/docs/help?id=mapping-pino-log-levels-to-google-cloud-logging-stackdriver-severity-levels
const PinoLevelToSeverityLookup: { [key: string]: string } = {
  trace: 'DEBUG',
  debug: 'DEBUG',
  info: 'INFO',
  warn: 'WARNING',
  error: 'ERROR',
  fatal: 'CRITICAL',
};

export const serverOnlyLogger = pino({
  messageKey: 'message',
  formatters: {
    messageKey: 'message',
    level(label, number) {
      return {
        severity: PinoLevelToSeverityLookup[label] || PinoLevelToSeverityLookup.info,
        level: number,
      };
    },
  },
  browser: { disabled: true },
});

export const logger = pino({
  messageKey: 'message',
  formatters: {
    messageKey: 'message',
    level(label, number) {
      return {
        severity: PinoLevelToSeverityLookup[label] || PinoLevelToSeverityLookup.info,
        level: number,
      };
    },
  },
});
